import { useCallback } from 'modules/core/hooks/useCallback'

import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'

import { useCurrentPage } from '../../../hooks/useCurrentPage'
import { CustomizableTableProps } from '../types'

interface Props {
  group?: InsightTableGroupBy
  setGroup: (value?: InsightTableGroupBy) => void
  tableProps: CustomizableTableProps
}

export const GroupBy = ({ group, setGroup, tableProps }: Props) => {
  const { groupByComponent } = tableProps
  const currentRoute = useCurrentPage()

  const handleGroupChanged = useCallback(
    (value?: InsightTableGroupBy) => {
      setGroup(value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentRoute]
  )

  if (!groupByComponent) return null

  return groupByComponent({ group, onChange: handleGroupChanged })
}
